import { render, staticRenderFns } from "./Zones.vue?vue&type=template&id=c6486d46&scoped=true"
import script from "./Zones.vue?vue&type=script&lang=js"
export * from "./Zones.vue?vue&type=script&lang=js"
import style0 from "./Zones.vue?vue&type=style&index=0&id=c6486d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6486d46",
  null
  
)

export default component.exports